export default function endpoint() {
    return process.env.REACT_APP_ENV === "production"
        ? "europe-west3-apomapdreinull"
        : "europe-west3-apomap-staging";
}
